import React from "react";
import "./style.css";
import CarUpdateWizard from "./Wizard";

const HERO_IMAGE = "/images/hero-car-steps.jpg";

export const CarUpdate = () => {
  return (
    <div className="pi-car-update">
      <header className="pi-inner-hero">
        <div className="pi-inner-hero__media" aria-hidden>
          <img
            className="pi-inner-hero__media-img"
            src={`${process.env.PUBLIC_URL}${HERO_IMAGE}`}
            alt=""
          />
          <div className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden>
          <div className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <div className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <div className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy">
            <p className="pi-inner-hero__label">Vehicle details</p>
            <h1 className="pi-inner-hero__title">Tell us about your vehicle</h1>
            <p className="pi-inner-hero__lead">
              Answer a few questions so we can complete your vehicle profile.
            </p>
          </div>
        </div>
      </header>

      <section className="pi-car-update__body">
        <CarUpdateWizard />
      </section>
    </div>
  );
};

export default CarUpdate;
